import type { StatusTone } from '../../../ui-kit';
import type { StlLeadCard, StlStatus } from '../../../services/speedToLeadService';

/** The chip a lead wears, in every list and in its story. */
const CHIPS: Record<StlStatus, { tone: StatusTone; label: string }> = {
  new: { tone: 'neutral', label: 'Just arrived' },
  waiting: { tone: 'neutral', label: 'Call coming up' },
  calling: { tone: 'good', label: 'On a call' },
  transferred: { tone: 'good', label: 'Talked to a specialist' },
  scheduled: { tone: 'good', label: 'Call booked' },
  follow_up: { tone: 'neutral', label: 'Specialist will call' },
  closed: { tone: 'neutral', label: 'Not interested' },
  needs_person: { tone: 'warning', label: 'Needs a person' },
};

export function statusChip(status: StlStatus): { tone: StatusTone; label: string } {
  return CHIPS[status] ?? { tone: 'neutral', label: status };
}

/** The chip for a lead on the move: the live call, or the specialist's phone ringing, says more than its status. */
export function liveChip(lead: StlLeadCard): { tone: StatusTone; label: string } {
  if (lead.handing_over) return { tone: 'good', label: 'Ringing the specialist' };
  if (lead.call_status === 'ringing') return { tone: 'good', label: 'Ringing' };
  if (lead.call_status === 'in progress') return { tone: 'good', label: 'On the call' };
  if (lead.call_status === 'ended') return { tone: 'neutral', label: 'Call ended · reading it' };
  return statusChip(lead.status);
}
